import Playback             from '../Playback/Playback';
import getHumanReadableTime from '../Playback/Util/getHumanReadableTime';

import TimelineStatus from './Constants/TimelineStatus';
import ITimeline      from './Interfaces/ITimeline';

class Timeline implements ITimeline {
    public multiplierProgress: number = 0;
    public multiplierInspect: number = 0;
    public timelineStatus: TimelineStatus = TimelineStatus.TRACKING;
    public playback: Playback = null;

    public get isTracking(): boolean {
        return this.timelineStatus === TimelineStatus.TRACKING;
    }

    public get isScrubbing(): boolean {
        return this.timelineStatus === TimelineStatus.SCRUBBING;
    }

    public get percentProgress(): number {
        let value: number;

        if (this.isScrubbing) {
            value = this.multiplierProgress * 100;
        } else {
            value = (this.playback.adjustedCurrentTime / this.playback.duration) * 100;
        }

        return Math.max(0, Math.min(100, value));
    }

    public get percentInspect(): number {
        return this.multiplierInspect * 100;
    }

    public get inspectTime(): number {
        return this.playback.duration * this.multiplierInspect;
    }

    public get humanReadableInspectTime(): string {
        return getHumanReadableTime(this.inspectTime, true, this.playback.isAtLeastOneHour);
    }
}

export default Timeline;